module.exports = __webpack_public_path__ + "assets/img/contract.d3b0be51.png";